<div class="top-bar">
  <div class="tabs">
    <div [class.active]="currentTab === 'EDITOR'" (click)="switchTab('EDITOR')" class="clickable tab" translate="CALLS.EDITOR"></div>
    @if (call.isOutlineReady) {
      <div [class.active]="currentTab === 'OUTLINE'" (click)="switchTab('OUTLINE')" class="clickable tab" translate="CALLS.OUTLINE"></div>
    }
  </div>
  @if (call.isPostProcessingComplete) {
    <div class="buttons">
      @if (currentTab === 'OUTLINE') {
        @if (showExpandAll) {
          <button mat-icon-button (click)="expandAll()">
            <mat-icon fontSet="material-symbols-outlined">expand_all</mat-icon>
          </button>
        } @else {
          <button mat-icon-button (click)="collapseAll()">
            <mat-icon fontSet="material-symbols-outlined">collapse_all</mat-icon>
          </button>
        }
      }
      @if (canUserEdit && currentTab === 'EDITOR' && !useTiptapEditor) {
        <button mat-icon-button (click)="showRevisionHistory()" [matTooltip]="'CALLS.SHOW_REVISION_HISTORY' | translate" [disabled]="isEditorLockedByOtherUser">
          <mat-icon>timeline</mat-icon>
        </button>
        <button mat-icon-button (click)="resetEditor()" [matTooltip]="'CALLS.RESET_EDITOR' | translate" [disabled]="isEditorLockedByOtherUser">
          <mat-icon>history</mat-icon>
        </button>
      }
      @if (currentTab === 'EDITOR' && hasCitations) {
        <button
          mat-icon-button
          (click)="toggleCitations()"
          [matTooltip]="(showCitations ? 'EDITOR.SETTINGS.HIDE_CITATIONS' : 'EDITOR.SETTINGS.SHOW_CITATIONS') | translate"
        >
          <mat-icon>{{ showCitations ? 'link' : 'link_off' }}</mat-icon>
        </button>
      }
      @if (currentTab === 'EDITOR' && !useTiptapEditor) {
        <button
          mat-icon-button
          (click)="toggleWordCount()"
          [matTooltip]="(showWordCount ? 'EDITOR.SETTINGS.HIDE_WORD_COUNT' : 'EDITOR.SETTINGS.SHOW_WORD_COUNT') | translate"
        >
          <mat-icon>{{ showWordCount ? 'font_download_off' : 'font_download' }}</mat-icon>
        </button>
      }
      @if (call.useNewEditor && currentTab === 'EDITOR') {
        <button
          mat-icon-button
          (click)="useTiptapEditor = !useTiptapEditor"
          [matTooltip]="
            (useTiptapEditor ? 'CALLS.NEW_EDITOR.TOGGLE_BUTTON.DISABLE_NEW_EDITOR_TOOLTIP' : 'CALLS.NEW_EDITOR.TOGGLE_BUTTON.ENABLE_NEW_EDITOR_TOOLTIP')
              | translate
          "
        >
          <mat-icon>{{ useTiptapEditor ? 'auto_fix_off' : 'auto_fix_normal' }}</mat-icon>
        </button>
      }
      @if (currentUser$ | async; as user) {
        @if (currentTab !== 'OUTLINE' || user.organization.allowOutlineDownload) {
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>download</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="exportDocument('pdf')">PDF</button>
            <button mat-menu-item (click)="exportDocument('docx')">DOCX</button>
          </mat-menu>
        }
      }
    </div>
  }
</div>

<div class="content">
  @if (currentTab === 'EDITOR') {
    @if (call.useNewEditor && useTiptapEditor) {
      <app-tiptap-editor
        [call]="call"
        [canUserEdit]="canUserEdit"
        (openDocument)="openDocument.emit($event)"
        (openMeeting)="openMeeting.emit()"
      ></app-tiptap-editor>
    } @else {
      <app-editor
        [call]="call"
        [canUserEdit]="canUserEdit"
        [canUserComment]="canUserComment"
        (isLocked)="isEditorLockedByOtherUser = $event"
        (openAgendaUpload)="openAgendaUpload.emit()"
        (openDocument)="openDocument.emit($event)"
        (openMeeting)="openMeeting.emit()"
      ></app-editor>
    }
  } @else if (currentTab === 'OUTLINE') {
    <app-outline [call]="call"></app-outline>
  }
</div>
